import React from 'react';
import { Popconfirm } from 'antd';

const PopComponent = ({ children, ...otherProps }) => (
  <Popconfirm okText="Não" cancelText="Sim" {...otherProps}>
    {children}
  </Popconfirm>
);

export default PopComponent;
